// extracted by mini-css-extract-plugin
module.exports = {"group":"ProviderGroupItem__group__W4XWt","header":"ProviderGroupItem__header__v2T-F","label":"ProviderGroupItem__label__Ynbym","logo":"ProviderGroupItem__logo__q4x-J"};